import { EmployeeReport } from '../../../types/apiDomain';
import requestReport, { ReportParams } from './requestReport';

export default (params: ReportParams) => requestReport<EmployeeReport>(params, `/api/report/employee`);
